const setErrorMessage = ({ commit }, payload) =>
  new Promise(() => {
    commit("SET_ERROR_MESSAGE", payload);
  });
const removeErrorMessage = ({ commit }) =>
  new Promise(() => {
    commit("REMOVE_ERROR_MESSAGE");
  });

export default {
  setErrorMessage,
  removeErrorMessage
};
